export const COLLECTION_METHOD = {
  FingerPrick: {id: 1, name: "Finger Prick", name2: "Finger prick kit"},
  HomePhlebotomy: {id: 2, name: "Home phlebotomy appointment", name2: "Home phlebotomy appointment"},
  PhlebotomyKit: {id: 3, name: "Organise a phlebotomist myself", name2: "Organise a phlebotomist myself"},
  PartnerClinic: {id: 5, name: "Partner clinic", name2: "Partner clinic"},
};
